import { useTracking } from 'react-tracking';

import { Alert, useMount } from '@simplywallst/ui-core';

import { CreateLinkedPortfolio } from '../../../../components/PortfolioLinking';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import { PortfolioPageHeader } from '../PortfolioPageHeader';

import { Wrapper, Content } from './styled';

type Props = {
  portfolio?: Portfolio;
};

const LinkingErrorState = ({ portfolio }: Props) => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    modifier: 'linkingErrorState',
  });

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  return (
    <Track>
      <PortfolioPageHeader portfolio={portfolio} />
      <Wrapper
        data-cy-id="linking-error-state"
        placeItems="center"
        placeContent="center"
        gap="24px"
      >
        <Alert styleType="negative">
          Something went wrong! Please try to connect with your brokerage again.
        </Alert>
        <Content templateRows="320px" justifyContent="center">
          <CreateLinkedPortfolio />
        </Content>
      </Wrapper>
    </Track>
  );
};

export default LinkingErrorState;
